// Environment configuration with validation
interface EnvConfig {
  API_BASE_URL: string;
  NODE_ENV: string;
  GOOGLE_CLIENT_ID: string;
  ENABLE_MOCK_DATA: boolean;
  DEBUG_MODE: boolean;
  SENTRY_DSN?: string;
  ANALYTICS_ID?: string;
}

// Validate required environment variables
const validateEnv = () => {
  const requiredVars = ["VITE_API_BASE_URL"];
  const missing = requiredVars.filter((varName) => !import.meta.env[varName]);

  if (missing.length > 0) {
    console.warn(`Missing environment variables: ${missing.join(", ")}`);
  }
};

// Parse boolean environment variables
const parseBoolean = (
  value: string | undefined,
  defaultValue: boolean = false,
): boolean => {
  if (!value) return defaultValue;
  return value.toLowerCase() === "true";
};

// Environment configuration
// NOTE: Variables are managed by igp-infra in production/staging
// For local development, defaults are used
export const env: EnvConfig = {
  API_BASE_URL: import.meta.env.VITE_API_BASE_URL || "http://localhost:8080",
  NODE_ENV: import.meta.env.NODE_ENV || "development",
  GOOGLE_CLIENT_ID: import.meta.env.VITE_GOOGLE_CLIENT_ID || "",
  ENABLE_MOCK_DATA: parseBoolean(import.meta.env.VITE_ENABLE_MOCK_DATA, false),
  DEBUG_MODE: parseBoolean(import.meta.env.VITE_DEBUG_MODE, false),
  SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN,
  ANALYTICS_ID: import.meta.env.VITE_ANALYTICS_ID,
};

// Validate environment on import
validateEnv();

// Export individual configs for convenience
export const isDevelopment = env.NODE_ENV === "development";
export const isProduction = env.NODE_ENV === "production";
export const isMockEnabled = env.ENABLE_MOCK_DATA;
export const isDebugMode = env.DEBUG_MODE;
